module.exports = __webpack_public_path__ + "img/our_advantage_banner.c0f9516b.png";